'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _reactScroll = require('react-scroll');

var _components = require('../../components');

var _Methodology = require('./Methodology.css');

var _Methodology2 = _interopRequireDefault(_Methodology);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Methodology = (_dec = (0, _reactCssModules2.default)(_Methodology2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Methodology, _Component);

  function Methodology(props) {
    (0, _classCallCheck3.default)(this, Methodology);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Methodology.__proto__ || (0, _getPrototypeOf2.default)(Methodology)).call(this, props));

    _this.state = {
      title: 'Methodology',
      description: 'Methodology for the Retirement Plan Sustainability Scorecard',
      url: _config2.default.domain + _config2.default.routes.methodology
    };
    return _this;
  }

  (0, _createClass3.default)(Methodology, [{
    key: 'render',
    value: function render() {
      var fffIcon = require('../../../static/images/icons/fff-icn-clr.png');
      var ffbIcon = require('../../../static/images/icons/ffb-icon.svg');
      var ffiIcon = require('../../../static/images/icons/ffi-icon.svg');
      var dffIcon = require('../../../static/images/icons/dff-icn-clr.png');
      var gefIcon = require('../../../static/images/icons/gef-icn-clr.png');
      var gffIcon = require('../../../static/images/icons/gff-icn-clr.png');
      var pffIcon = require('../../../static/images/icons/pff-icn-clr.png');
      var wffIcon = require('../../../static/images/icons/wff-icn-clr.png');
      var tffIcon = require('../../../static/images/icons/tff-icn-clr.png');

      // const graySquare = (
      //   <div styleName='result-shape-txt-wrap'>
      //     <div styleName='result-shape-wrap'>
      //       <div title='Coming soon' styleName='gray-square'/>
      //     </div>
      //     <div styleName='result-val result-val-soon'>
      //       Coming soon
      //     </div>
      //   </div>
      // )

      var redOctagon = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Poor', styleName: 'red-octagon' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'result-val result-val-poor' },
          'Poor'
        )
      );

      var yellowSquare = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Fair', styleName: 'yellow-square' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'result-val result-val-fair' },
          'Fair'
        )
      );

      var greenCircle = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Good', styleName: 'green-circle' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'result-val result-val-good' },
          'Good'
        )
      );

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page', id: 'top' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement('div', { styleName: 'anchor', id: 'top' }),
          _react2.default.createElement(
            'h1',
            { styleName: 'small-page-title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'methodology-wrap' },
            _react2.default.createElement(
              'p',
              null,
              'We designed the retirement plan sustainability scorecard around three questions:'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              _react2.default.createElement(
                'b',
                null,
                'What are the environmental and social sustainability risks of the default plan option?'
              )
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              _react2.default.createElement(
                'b',
                null,
                'How much money do plan participants have invested in different sustainability risk categories?'
              )
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              _react2.default.createElement(
                'b',
                null,
                'Do plan participants have any access to sustainable investments?'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'To answer these questions, we find out what funds are offered by the retirement plan, and what companies those funds are invested in.'
            ),
            _react2.default.createElement(
              'nav',
              null,
              [[0, 'How retirement plans are structured', 'retirement-plans'], [0, 'Qualified Default Investment Alternatives (QDIAs)', 'qdia'], [0, 'Target date funds', 'target-dates'], [0, 'Mutual funds', 'mutual-funds'], [0, 'Companies', 'companies'], [1, 'Publicly-traded companies', 'publicly-traded-companies'], [0, 'Rating mutual funds', 'rating-mutual-funds'], [1, 'Fossil fuel grade', 'fossil-fuel-grade'], [1, 'Fossil finance grade', 'fossil-finance-grade'], [1, 'Fossil insurance grade', 'fossil-insurance-grade'], [1, 'Deforestation grade', 'deforestation-grade'], [1, 'Gender equality grade', 'gender-equality-grade'], [1, 'Civilian firearm grade', 'civilian-firearms-grade'], [1, 'Prison industrial complex grade', 'prison-industrial-complex-grade'], [1, 'Military weapons grade', 'military-weapons-grade'], [1, 'Tobacco grade', 'tobacco-grade'], [1, 'Portfolio analysis details', 'portfolio-analysis-details'], [0, 'Rating target date funds', 'rating-target-date-funds'], [1, 'Why the 2050 fund?', 'why-2050'], [0, 'Rating retirement plans based on the default investment', 'rating-retirement-plan-default'], [1, 'Why is the default investment option so important?', 'why-default-is-important'], [0, 'Retirement plan options beyond the default investment', 'retirement-plan-options-beyond-default'], [1, 'Collective trusts', 'collective-trusts'], [0, 'Calculating retirement plan allocations to sustainability risks', 'allocations-sustainability-risks'], [0, 'Identifying whether retirement plans offer access to sustainable options', 'sustainable-options'], [1, 'Self-directed option', 'self-directed-option'], [0, 'Source data', 'source-data']].map(function (e, i) {
                return _react2.default.createElement(
                  'button',
                  {
                    key: e[2],
                    styleName: 'scroll-to-item'
                  },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      to: e[2],
                      spy: true,
                      smooth: true,
                      duration: 500,
                      title: e[1]
                    },
                    _react2.default.createElement(
                      'p',
                      { styleName: 'level-' + e[0] },
                      e[1]
                    )
                  )
                );
              })
            ),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'retirement-plans' }),
            _react2.default.createElement(
              'h2',
              null,
              'How retirement plans are structured'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Most retirement plans are structured as a list of 10-20 investment options. When a plan participant chooses to allocate their contributions to one or more of these investment options, that money is then invested by the fund managers into the stock market.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'These types of retirement plans are called ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.investopedia.com/terms/d/definedcontributionplan.asp' },
                'defined contribution plans'
              ),
              '. The most common type of defined contribution plan is the 401(k); another common type is the 403(b). Both of these plan types give participants the ability to choose for themselves which plan options to invest in.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'There are often tax advantages to investing via a defined contribution plan. However, defined contribution plans require employees to invest and manage their own money in order to save up enough for retirement later in life. This means, depending on the investments chosen, a plan participant may have more or less financial risk.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'qdia' }),
            _react2.default.createElement(
              'h2',
              null,
              'Qualified Default Investment Alternatives (QDIAs)'
            ),
            _react2.default.createElement(
              'p',
              null,
              'To help plan participants manage that financial risk, most defined contribution plans have a default investment option, where any new participants have contributions allocated unless they specify otherwise. This default option is known as the ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.betterment.com/resources/what-is-a-qualified-default-investment-alternative-qdia/' },
                'Qualified Default Investment Alternative'
              ),
              ', or QDIA.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'A plan QDIA must meet certain requirements from the Department of Labor (DOL), and these funds are usually diversified investments that invest broadly in global stock markets. They\u2019re designed to make sure that any new plan participant can feel relatively secure choosing that option to save for their retirement.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Some plans use a balanced fund (a fund that invests partly in stocks, partly in bonds) as the QDIA. But a more common option, especially in plans from large companies with a significant amount of assets under management, are a type of investment fund called target date funds.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'target-dates' }),
            _react2.default.createElement(
              'h2',
              null,
              'Target date funds'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.investopedia.com/terms/t/target-date_fund.asp' },
                'Target date funds'
              ),
              ' are broadly diversified investments, similar to balanced funds, but they are offered as a series of funds, aimed at different \u201Ctarget dates\u201D.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As a plan participant moves closer to retirement, they often prefer safer portfolios. Nobody wants to arrive at retirement and find out their savings have been lessened at the last moment due to risky investments. But when retirement is further away, introducing more risk can be a way to achieve greater gains, with the knowledge that any risk-related losses could be offset by the additional time in market.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Target date fund series offer funds aimed at different \u201Ctarget dates\u201D, marketed to savers who are planning to retire around those dates. For example, someone looking to retire in the year 2030 would invest in the 2030 version of a target date fund; someone younger expecting to retire in the year 2060 would invest in the 2060 version.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'As that \u201Ctarget date\u201D year comes closer in time, the portfolio moves away from riskier investments like stocks, and invests more in safer investments like bonds. This gives the plan participant the security of knowing that even if they keep their savings in that fund throughout their working career, the fund manager is working behind the scenes to manage risk appropriate to their circumstances. This is what makes them good candidates for retirement plan default options.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'These target date funds often don\u2019t invest directly in stocks, but invest in other ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.investopedia.com/terms/m/mutualfund.asp' },
                'mutual funds'
              ),
              ' (usually from the same asset manager to reduce fees). For example, here are the holdings of a very popular target date fund, the ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://investor.vanguard.com/mutual-funds/profile/portfolio/vfifx' },
                'Vanguard Target Retirement 2050 fund'
              ),
              ':'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              '1. Vanguard Total Stock Market Index Fund \u2013 54%'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              '2. Vanguard Total International Stock Index Fund \u2013 36.5%'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              '3. Vanguard Total Bond Market II Index Fund \u2013 6.5%'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              '4. Vanguard Total International Bond Index Fund \u2013 2.9%'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              '5. Vanguard Total International Bond II Index \u2013 0.1% '
            ),
            _react2.default.createElement(
              'p',
              null,
              'The other target dates offered by this target and series will usually invest in the same portfolio of funds, but with different allocations to the stock funds and bond funds (more in bonds for dates closer to today, more in stocks for dates further out).'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'mutual-funds' }),
            _react2.default.createElement(
              'h2',
              null,
              'Mutual funds'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This means that to find out what the Vanguard Target Retirement 2050 fund is investing in, we need to know what the \u201Cfunds inside the fund\u201D are invested in.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Since 2015, As You Sow\u2019s ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://fossilfreefunds.org/' },
                'Fossil Free Funds'
              ),
              ' has been analyzing the holdings of mutual funds and rating them on fossil fuel investments and overall carbon footprint. Our fund screeners are 100% free to use, and provide transparency to find out if mutual funds are investing in oil majors like ExxonMobil and Chevron, coal mining companies like BHP, and fossil-fired utilities like Duke Energy.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Since we released Fossil Free Funds, we\u2019ve expanded our sustainability ratings to include ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://deforestationfreefunds.org/' },
                'deforestation'
              ),
              ', as well as social issues like ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://genderequalityfunds.org/' },
                'gender equality'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://gunfreefunds.org/' },
                'civilian firearms'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://prisonfreefunds.org/' },
                'the prison industrial complex'
              ),
              ', ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://weaponfreefunds.org/' },
                'arms manufacturers and military contractors'
              ),
              ', and ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://tobaccofreefunds.org/' },
                'tobacco'
              ),
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For each of these issues, we produce ratings for mutual funds based on what stocks the fund is invested in. The first step is to determine which companies have sustainability risks for these issues.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'companies' }),
            _react2.default.createElement(
              'h2',
              null,
              'Companies'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Most people have heard of oil giants like ExxonMobil. But the fossil fuel industry includes many smaller companies that people haven\u2019t heard of, and if they were to take the time to dig into the fund portfolio, they might not recognize as fossil fuel companies. This includes pipeline companies, oil field services, gas utilities, and more.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For other issues, the sustainability risks are even harder to investigate. Companies that have poor gender balance in their workforce, for example, are usually not anxious to make this known to their investors. Companies with contracts to provide services to prisons and immigration jails may seem innocuous without this transparency.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'To identify companies within a fund portfolio as sustainability risks, we depend on research from investor research firms and non-profit advocacy groups. A full breakdown of the various company screens we track ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.companies, xstrong: true },
                'can be found here.'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'publicly-traded-companies' }),
              _react2.default.createElement(
                'h3',
                null,
                'Publicly-traded companies'
              ),
              _react2.default.createElement(
                'p',
                null,
                'There are many types of companies with sustainability risks currently operating, including privately held and state-owned companies. Because our analysis is based on tracking stock investments by mutual funds and retirement plans, our company lists are composed of publicly-traded companies that issue stock.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'rating-mutual-funds' }),
            _react2.default.createElement(
              'h2',
              null,
              'Rating mutual funds'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Once we\u2019ve found a dataset that identifies companies with sustainability risks for a given issue, we\u2019re ready to rate mutual funds and ',
              _react2.default.createElement(
                _components.Link,
                { xstrong: true, to: 'https://www.investopedia.com/terms/e/etf.asp' },
                'exchange-traded funds (ETFs)'
              ),
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We produce letter grade ratings for mutual funds on different sustainability issues: fossil fuels, deforestation, gender equality, civilian firearms, arms manufacturers and military contractors, and tobacco.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The rating methodology for each issue is based on the company data we have available, and the way funds across our research universe invest in those companies.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'fossil-fuel-grade' }),
              _react2.default.createElement('img', {
                src: fffIcon,
                styleName: 'icn',
                alt: 'Fossil fuels'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Fossil fuel grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The fossil fuel grade is based on the fund\u2019s exposure to ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#fossilfuels', xstrong: true },
                  'five fossil fuel screen lists'
                ),
                ', tracking several thousand companies primarily in the energy and utility sectors.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'higher-risk-wrap' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'higher-risk-icon' },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Two of the screens - top carbon reserve owners and top coal-fired utilities - are considered ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'higher risk'
                  ),
                  '. Investment in these companies automatically earns a fund a fossil fuel grade of C or lower.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'The grade also incorporates investments in ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#fossilfinance', xstrong: true },
                  'banks financing fossil fuels'
                ),
                ' and ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#fossilinsurance', xstrong: true },
                  'insurers underwriting fossil fuels'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund doesn\'t invest in any of the fossil fuel companies or related financial companies we look for, it earns an A grade. '
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Fossil fuel exposure is 0%, fossil fuel finance and insurance exposure is 0%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in fossil fuel companies or related financial companies, we measure the percentage of exposure to assign a grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Fossil fuel exposure between 0% and 3%; OR, fossil fuel exposure is 0%, fossil fuel finance and insurance exposure above 0%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Fossil fuel exposure between 3% and 5.5%; OR, fossil fuel exposure below 3%, with investments in top 200 carbon reserve owners and/or top 30 coal-fired utilities'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Fossil fuel exposure between 5.5% and 9%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Fossil fuel exposure between 9% and 100%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These percentage thresholds reflect the distribution of results across funds, placing a roughly equal number of funds from the analysis universe in each grade range.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'fossil-finance-grade' }),
              _react2.default.createElement('img', {
                src: ffbIcon,
                styleName: 'icn',
                alt: 'Fossil finance'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Fossil finance grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The fossil finance grade is based on the fund\u2019s exposure to ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#fossilfinance', xstrong: true },
                  'banks that lend to fossil fuels.'
                ),
                ' It is a standalone grade, and also impacts the fund\'s fossil fuel grade.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'To rate mutual funds on fossil fuel finance, we use data from ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://www.bankingonclimatechaos.org/',
                    title: 'Banking on Climate Chaos',
                    xstrong: true
                  },
                  'Banking on Climate Chaos'
                ),
                '. The Banking on Climate Chaos report looks at 60 of the largest commercial and investment banks and tracks their total fossil fuel financing: lending, and underwriting debt and equity issuances. The data covers 2016 through 2023. The top bank, JPMorgan Chase, had over $430 billion in fossil fuel financing over this time period. For our fund ratings, we normalize the bank financing amounts from $USD to a 0-10 scale, where 10 is the worst score possible. These 0-10 figures represent a ',
                _react2.default.createElement(
                  'b',
                  null,
                  'company fossil fuel finance risk score'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We then use the normalized financing amounts to calculate a ',
                _react2.default.createElement(
                  'b',
                  null,
                  'fund fossil fuel finance risk score'
                ),
                '. For each flagged bank holding, the company risk score is multiplied by the holding weight (the percent of the fund\'s portfolio that holding accounts for). For example, if a flagged bank holding had a company risk score of 5, and made up 2% of the fund, 10 points would be assigned to the fund (5 times 2). These points are summed up and represent the fund fossil fuel finance risk score.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The last step is using the fund risk score to assign a ',
                _react2.default.createElement(
                  'b',
                  null,
                  'fund fossil fuel finance grade'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund doesn\'t invest in any of the fossil finance companies we look for, it earns an A grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Fossil finance exposure is 0%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in fossil finance companies, the fund risk score is used to assign a grade. Funds are grouped into 4 tiers:'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Fossil finance score in 0 - 5 range'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Fossil finance score in 5 - 15 range'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Fossil finance score in 15 - 25 range'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Fossil finance score in 25+ range'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'fossil-insurance-grade' }),
              _react2.default.createElement('img', {
                src: ffiIcon,
                styleName: 'icn',
                alt: 'Fossil insurance'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Fossil insurance grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The fossil insurance grade is based on the fund\u2019s exposure to ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#fossilinsurance', xstrong: true },
                  'insurance companies that underwrite and invest in fossil fuels.'
                ),
                ' It is a standalone grade, and also impacts the fund\'s fossil fuel grade.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'To rate mutual funds on fossil fuel insurance, we use data from the ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: 'https://docs.google.com/spreadsheets/d/157kNo3-xg7qeVHi8SF21VqjXKrSjHixL9UOKFTp8PKQ/edit#gid=769793980',
                    title: 'Insure Our Future Scorecard',
                    xstrong: true
                  },
                  'Insure Our Future Scorecard'
                ),
                '. The Insure Our Future Scorecard looks at 30 of the largest primary insurers and reinsurers and rates their fossil fuel insurance policies. For our fund ratings, we normalize the insurance policy ratings to a 0-10 scale, where 10 is the worst score possible. These 0-10 figures represent a ',
                _react2.default.createElement(
                  'b',
                  null,
                  'company fossil fuel insurance risk score'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We then use the normalized policy ratings to calculate a ',
                _react2.default.createElement(
                  'b',
                  null,
                  'fund fossil fuel insurance risk score'
                ),
                '. For each flagged insurance holding, the company risk score is multiplied by the holding weight (the percent of the fund\'s portfolio that holding accounts for). For example, if a flagged insurance holding had a company risk score of 5, and made up 2% of the fund, 10 points would be assigned to the fund (5 times 2). These points are summed up and represent the fund fossil fuel insurance risk score.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The last step is using the fund risk score to assign a ',
                _react2.default.createElement(
                  'b',
                  null,
                  'fund fossil fuel insurance grade'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund doesn\'t invest in any of the fossil insurance companies we look for, it earns an A grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Fossil insurance exposure is 0%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in fossil insurance companies, the fund risk score is used to assign a grade. Funds are grouped into 4 tiers:'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Fossil insurance score in 0 - 5 range'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Fossil insurance score in 5 - 15 range'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Fossil insurance score in 15 - 25 range'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Fossil insurance score in 25+ range'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'deforestation-grade' }),
              _react2.default.createElement('img', {
                src: dffIcon,
                styleName: 'icn',
                alt: 'Deforestation'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Deforestation grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The deforestation grade is based on the fund\u2019s exposure to a ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#deforestation', xstrong: true },
                  'list of deforestation-risk companies'
                ),
                ' identified in partnership with ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://foe.org/' },
                  'Friends of the Earth U.S.'
                ),
                ', compiled from independent research as well as from existing resources within the civil society research and investor advocacy communities on forest-risk companies, including ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://forestsandfinance.org/', target: '_blank',
                    title: 'Forests & Finance' },
                  'Forests & Finance'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://forest500.org/', target: '_blank', title: 'Forest500' },
                  'Forest500'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.cdp.net/en/forests', target: '_blank', title: 'CDP Forests' },
                  'CDP Forests'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://supply-change.org/', target: '_blank',
                    title: 'Supply Change.org' },
                  'Supply Change.org'
                ),
                ' and ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.spott.org/', target: '_blank', title: 'ZSL SPOTT' },
                  'ZSL SPOTT'
                ),
                '. The screens include deforestation-risk agricultural commodity producer/traders (palm oil, paper/pulp, rubber, timber, cattle, and soy); financial companies involved in lending and underwriting to deforestation-risk producers and traders; and major consumer goods companies that source from deforestation-risk producers and traders.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'higher-risk-wrap' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'higher-risk-icon' },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The deforestation-risk producer/trader screen is considered ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'higher risk'
                  ),
                  '. Investment in these companies automatically earns a fund a deforestation grade of C or lower.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund doesn\'t invest in any of the deforestation-risk companies we look for, it earns an A grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Deforestation-risk screens exposure 0%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The screens are split into two tiers, with investments in producer/traders considered a higher risk. If a fund doesn\u2019t invest in any of the deforestation-risk producer/traders, but has investments in the financial companies or major consumer brands screens, it earns a B grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Deforestation-risk producer/trader screen exposure 0%; has investments in banks and lenders and/or major consumer brands'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in deforestation-risk producer/trader companies, we measure the percentage of exposure to assign a grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Deforestation-risk producer/trader screen exposure between 0% and 0.5%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Deforestation-risk producer/trader screen exposure between 0.5% and 1.5%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Deforestation-risk producer/trader screen exposure between 1.5% and 100%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These brackets reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in each grade range.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'gender-equality-grade' }),
              _react2.default.createElement('img', {
                src: gefIcon,
                styleName: 'icn',
                alt: 'Gender equality'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Gender equality grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The gender equality grade is based on corporate data from ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://equileap.com/' },
                  'Equileap'
                ),
                ' that ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#genderequality', xstrong: true },
                  'tracks how companies perform'
                ),
                ' on four gender equality subcategories: gender balance in leadership and workforce; equal compensation and work life balance; policies promoting gender equality; and commitment, transparency, and accountability.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'First, a gender equality fund score is produced by applying the Equileap company scores to the fund holdings, then calculating the average score weighted by holding weight.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Then, funds are ranked against other funds in the same investment group (U.S. equity funds, international equity funds, sector funds, and allocation funds). Based on these group rankings, funds are assigned a letter grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Gender equality group ranking between 80% and 100%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Gender equality group ranking between 60% and 80%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Gender equality group ranking between 40% and 60%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Gender equality group ranking between 20% and 40%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Gender equality group ranking between 0% and 20%'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'civilian-firearms-grade' }),
              _react2.default.createElement('img', {
                src: gffIcon,
                styleName: 'icn',
                alt: 'Civilian firearms'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Civilian firearm grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The civilian firearm grade is based on the fund\u2019s exposure to ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#civilianfirearms', xstrong: true },
                  'two screen lists'
                ),
                ': civilian firearm manufacturers, and retailers that sell firearms or ammunition to the civilian market.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'higher-risk-wrap' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'higher-risk-icon' },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The civilian firearm manufacturers screen is considered ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'higher risk'
                  ),
                  '. Investment in these companies automatically earns a fund a civilian firearm grade of C or lower.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund doesn\'t invest in any of the companies from the civilian firearm screens, it earns an A grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Civilian firearm screens exposure 0%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The screens are split into two tiers, with investments in civilian firearm manufacturers considered a higher risk. If a fund doesn\u2019t invest in any of the civilian firearm manufacturers, but has investments in the civilian firearm retailers screen, it earns a B grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Civilian firearm manufacturers screen exposure 0%; has investments in civilian firearm retailers'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in civilian firearm manufacturers, we measure the percentage of exposure to assign a grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Civilian firearm manufacturers screen exposure between 0% and 0.1%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Civilian firearm manufacturers trader screen exposure between 0.1% and 0.4%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Civilian firearm manufacturers screen exposure between 0.4% and 100%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These brackets reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in each grade range.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'prison-industrial-complex-grade' }),
              _react2.default.createElement('img', {
                src: pffIcon,
                styleName: 'icn',
                alt: 'Prison industrial complex'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Prison industrial complex grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The prison industrial complex grade is based on the fund\u2019s exposure to ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#prisonindustrialcomplex', xstrong: true },
                  'two screen lists'
                ),
                ': prison industry companies, and border industry companies. All the companies on both lists are identified by the ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://investigate.afsc.org/' },
                  'American Friends Service Committee\u2019s Investigate project'
                ),
                '.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'higher-risk-wrap' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'higher-risk-icon' },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The prison industrial complex-risk screens have a number of companies considered ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'higher risk'
                  ),
                  '. Investment in these companies automatically earns a fund a prison industrial complex grade of C or lower.'
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'div',
                { styleName: 'higher-risk-wrap' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'higher-risk-icon red' },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'There are also a number of private prison operators that are considered ',
                  _react2.default.createElement(
                    'b',
                    { styleName: 'red' },
                    'extreme risk'
                  ),
                  '. Investment in these companies automatically earns a fund a prison industrial complex grade of F.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund doesn\'t invest in any of the prison industrial complex-risk companies we look for, it earns an A grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Prison industrial complex-risk screens exposure 0%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The screens are split into two tiers, with both the prison industry and border industry screens having a subset of companies considered a higher risk. If a fund has investments in the prison industrial complex screens, but doesn\u2019t invest in any of the higher-risk companies, it earns a B grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Prison industrial complex higher risk screens exposure 0%; has investments in other prison industrial complex companies'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in the higher-risk companies from the prison industrial screens, we measure the percentage of exposure to assign a grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Prison industrial complex higher risk screens exposure between 0% and 1%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Prison industrial complex higher risk screens exposure between 1% and 2%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Prison industrial complex higher risk screens exposure between 2% and 100%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These brackets reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in each grade range.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'In addition, because the private operation of prison and jails represents the deepest form of corporate involvement in mass incarceration, any investments in the private prison operators screen earns an automatic F.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Private prison operators screen exposure between 3% and 100%'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'military-weapons-grade' }),
              _react2.default.createElement('img', {
                src: wffIcon,
                styleName: 'icn',
                alt: 'Military weapons'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Military weapons grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The military weapons grade is based on the fund\u2019s exposure to ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#militaryweapons', xstrong: true },
                  'arms manufacturers and military contractors.'
                ),
                ' This list includes two sub-categories: manufacturers and servicers of nuclear weapons; and current and recent manufacturers of controversial weapons, such as cluster munititions, anti-personnel landmines, incendiary weapons, and depleted uranium.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'higher-risk-wrap' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'higher-risk-icon' },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The nuclear weapons and controversial weapons lists are considered ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'higher risk'
                  ),
                  '. Investment in these companies automatically earns a fund a military weapons grade of C or lower.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund doesn\'t invest in any of the military weapons companies we look for, it earns an A grade. '
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Military weapons screens exposure 0%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The lists are split into two tiers, with companies involved in nuclear weapons and controversial weapons considered a higher risk. If a fund has investments in the military weapons list, but doesn\u2019t invest in any of the higher-risk companies, it earns a B grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Fund is not invested in nuclear weapons or controversial weapons, but is invested in military contractors, below the threshold of 2.5%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in the higher-risk companies from the military weapons list, we measure the percentage of exposure to assign a grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Fund is invested in nuclear weapons and/or controversial weapons below the threshold of 2.5%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Fund is invested in military contractors above the threshold of 2.5% and below the threshold of 4%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Fund is invested in military contractors above the threshold of 4%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These brackets reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in each grade range.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'tobacco-grade' }),
              _react2.default.createElement('img', {
                src: tffIcon,
                styleName: 'icn',
                alt: 'Tobacco'
              }),
              _react2.default.createElement(
                'h3',
                null,
                'Tobacco grade'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The tobacco grade is based on the fund\u2019s exposure to ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.routes.companies + '#tobacco', xstrong: true },
                  'two screen lists'
                ),
                ': tobacco companies that either produce tobacco or manufacture tobacco products identified by industry classifications; and a list of entertainment companies that promote tobacco to young audiences, identified by research from the ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://smokefreemovies.ucsf.edu/whos-accountable', target: '_blank',
                    title: 'UCSF Smoke Free Movies Database' },
                  'University of California, San Francisco Center for Tobacco Control Research and Education Smoke Free Movies Database'
                ),
                '.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'higher-risk-wrap' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'higher-risk-icon' },
                  _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-exclamation-triangle' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'The tobacco producer/manufacturer screen is considered ',
                  _react2.default.createElement(
                    'b',
                    null,
                    'higher risk'
                  ),
                  '. Investment in these companies automatically earns a fund a tobacco grade of C or lower.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund doesn\'t invest in any of the companies from the tobacco screens, it earns an A grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-a' },
                  'A'
                ),
                ' Tobacco-risk screens exposure 0%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The screens are split into two tiers, with investments in tobacco producer/manufacturers considered a higher risk. If a fund doesn\u2019t invest in any of the tobacco producer/manufacturers, but has investments in the entertainment companies screen, it earns a B grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-b' },
                  'B'
                ),
                ' Tobacco producer/manufacturers screen exposure 0%; has investments in entertainment companies that promote tobacco to young audiences'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund has investments in tobacco producer/manufacturers, we measure the percentage of exposure to assign a grade.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-c' },
                  'C'
                ),
                ' Tobacco producer/manufacturers screen exposure between 0% and 0.5%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-d' },
                  'D'
                ),
                ' Tobacco producer/manufacturers screen exposure between 0.5% and 1.2%'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'indent' },
                _react2.default.createElement(
                  'b',
                  { styleName: 'grade-f' },
                  'F'
                ),
                ' Tobacco producer/manufacturers screen exposure between 1.2% and 100%'
              ),
              _react2.default.createElement(
                'p',
                null,
                'These brackets reflect the distribution of results across funds, placing an approximately equal number of funds from the analysis universe in each grade range.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'portfolio-analysis-details' }),
              _react2.default.createElement(
                'h3',
                null,
                'Portfolio analysis details'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Long holdings only: When calculating a fund\'s exposure to a screen list, we only consider the portfolio\'s long investments, ignoring any shorts or liabilities. The formula for holding weight is ',
                _react2.default.createElement(
                  'i',
                  null,
                  'holding market value divided by sum of market value for all long holdings in the portfolio.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Analysis universe: The fund universe consists of open-end mutual funds and exchange-traded funds domiciled in the U.S. Currently, we don\u2019t have data on funds domiciled outside the U.S. The fund ratings are based on tracking stock investments in publicly-traded companies. Currently, we don\u2019t have data on fixed income assets. Because of this, we focus on funds that primarily invest in equities. We exclude funds below 50% rated from the analysis universe.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'rating-target-date-funds' }),
            _react2.default.createElement(
              'h2',
              null,
              'Rating target date funds'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Because target date funds are offered as a series, and because they are often structured as \u201Cfunds of funds\u201D, there are some extra steps involved in applying the letter grade rating systems.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'First, we unpack the funds held by the target date fund, and re-weight and recombine the holdings to produce a list of stocks held by the target date fund. For example, if a target date fund invests in two different mutual funds that both invest in ExxonMobil, those two ExxonMobil holdings are re-weighted and recombined to represent the total exposure of the target date fund to ExxonMobil.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Second, we use the 2050 version as the representative of the target date fund series. For most target date series, the 2050 fund will be approximately 90% invested in stocks, 10% invested in bonds and other fixed-income assets. Target date series usually have the same mix of stocks regardless of which date is chosen, but the percent allocated to stocks overall goes down for dates closer to today. This means that, for example, a 2030 version of a target date fund series will likely have exposure to the same companies as the 2050 version, but at lower percentages.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'why-2050' }),
              _react2.default.createElement(
                'h3',
                null,
                'Why the 2050 fund?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Because our overall retirement plan ratings are based on the default investment, and because these default investments are often a target date fund series, creating a different retirement plan rating for each version of a target date fund series didn\u2019t make sense to us. The 2050 version of a target date fund is marketed at savers who are looking to retire in the year 2050, which is 30 years away, meaning it is usually heavily weighted towards stocks vs. other asset classes. Because our analysis is based on tracking stock investments, this gives us a good representation of the asset manager\u2019s decisions in selecting investments for the target date fund portfolio.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'rating-retirement-plan-default' }),
            _react2.default.createElement(
              'h2',
              null,
              'Rating retirement plans based on the default investment'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The main scorecard for a retirement plan is based on the default investment, because the majority of plan assets tend to be allocated to that investment option. For example, the Amazon.com 401(k) has over 50% of employee contributions allocated to the Vanguard Target Retirement Fund series default option.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For each issue, we assign a rating of Good, Fair, or Poor, depending on how the default option is graded on our mutual fund rating systems. (If the default option is a target date fund series, we use the 2050 version \u2013 see above.)'
            ),
            _react2.default.createElement(
              'div',
              null,
              greenCircle
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Default option earns a grade of A for this issue.'
            ),
            _react2.default.createElement(
              'div',
              null,
              yellowSquare
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Default option earns a grade of B or C for this issue.'
            ),
            _react2.default.createElement(
              'div',
              null,
              redOctagon
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Default option earns a grade of D or F for this issue.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'In plain language, if a retirement plan earns a Poor rating on an issue, it means that the plan default option has significant exposure to companies that have sustainability risk for that issue.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'why-default-is-important' }),
              _react2.default.createElement(
                'h3',
                null,
                'Why is the default investment option so important?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The default option in a defined contribution plan often commands the majority of the plan assets. That\u2019s natural, as it\u2019s the option to which new plan participants have their contributions allocated, and many people never switch.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'But most employees assume the default option in their retirement plan is a safe choice. If climate risk and other sustainability issues are not incorporated into the portfolio management by the fund manager, employees could be exposed to financial risks from unsustainable investments. '
              ),
              _react2.default.createElement(
                'p',
                null,
                'Investing unsustainably carries real financial risks. It should be something you have to go out of your way to do; not the other way around. Given the scale of our sustainability challenges, we must make sustainability the default.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'retirement-plan-options-beyond-default' }),
            _react2.default.createElement(
              'h2',
              null,
              'Retirement plan options beyond the default investment'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Our retirement plan sustainability scorecard ratings are based primarily on the default option. But we also rate the other plan options so we can calculate the overall amounts the retirement plan has invested in different risk categories.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'For any plan options that are primarily invested in stocks, the scorecard will display the environmental and social ratings in the \u201CPlan investment options\u201D section.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'collective-trusts' }),
              _react2.default.createElement(
                'h3',
                null,
                'Collective trusts'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Target date fund series and other mutual funds are often offered in a variety of asset classes. A popular asset class for retirement plans are \u201Ccollective trusts\u201D, which are investments that operate the same way as a mutual fund, but are usually offered only to major investors like pension plans and corporate retirement plans. Collective trusts have fewer transparency requirements, so it\u2019s more difficult to access the investment holdings than it is with mutual funds and ETFs, which have regular disclosure requirements. If a retirement plan offers collective trusts, we identify mutual fund versions of those portfolios to use for calculating the fund ratings and other scorecard results.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'allocations-sustainability-risks' }),
            _react2.default.createElement(
              'h2',
              null,
              'Calculating retirement plan allocations to sustainability risks'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Using the results of the ratings for the plan default option and other plan offerings, we use the most recent available Form 5500 data to calculate the overall amounts the retirement plan has invested in different risk categories. These totals are shown as a bar chart, with figures listed in the \u201CAllocation details\u201D section.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The risk categories that we sum totals for are:'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Fossil fuels (including top 200 carbon reserve owners, Global Coal Exit List, and other oil/gas, coal, and utility companies identified by industry classifications)'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Deforestation-risk agribusiness commodity producer/traders (palm oil, cattle, soy, paper/pulp, timber, and rubber)'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Civilian firearm manufacturers'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Prison industrial complex, high-risk (including private prison operators)'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Arms manufacturers and military contractors (including nuclear weapons manufacturers/servicers and manufacturers of banned weapons like cluster munitions)'
            ),
            _react2.default.createElement(
              'p',
              { styleName: 'indent' },
              'Tobacco producer/manufacturers'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'sustainable-options' }),
            _react2.default.createElement(
              'h2',
              null,
              'Identifying whether retirement plans offer access to sustainable options'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If the default plan option is not a sustainable investment, we check to see if there\u2019s any way participants have other access to sustainable investing. Some retirement plans do offer a sustainable fund option, sometimes labeled as a \u201Csocially conscious\u201D, \u201Cresponsible\u201D, or \u201CESG\u201D option.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'If a retirement plan has a sustainable fund as a plan option, we calculate the percent of plan assets allocated to it, and show the fund ratings in the \u201CSustainable plan options\u201D section.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'indent' },
              _react2.default.createElement('div', { styleName: 'anchor', id: 'self-directed-option' }),
              _react2.default.createElement(
                'h3',
                null,
                'Self-directed option'
              ),
              _react2.default.createElement(
                'p',
                null,
                'A self-directed option, also referred to as a brokerage or mutual fund window, offers plan participants the ability to invest in much larger universe of funds beyond the direct plan options. This expanded universe usually includes sustainable funds, so a self-directed option is another way retirement plans can offer access to sustainable investments.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Here\u2019s the issue: a self-directed option moves much of the work of selecting investments onto the individual. It also increases the risk that participants may choose funds that are not appropriate for their circumstances. When they\u2019re available, they\u2019re not commonly used \u2013 ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.investmentnews.com/brokerage-windows-401k-dol-208416' },
                  'as of 2020'
                ),
                ', about 2.4% of participants in large and medium-sized 401(k)s used a self-directed option.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Retirement plans have a responsibility to offer sustainable investments directly in the plan line-up. If a plan doesn\u2019t directly offer any sustainable investments, a self-directed option is the only way for participants to invest sustainably. If a plan also doesn\u2019t have a self-directed option, this effectively forces plan participants to invest unsustainably.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { styleName: 'anchor', id: 'source-data' }),
            _react2.default.createElement(
              'h2',
              null,
              'Source data'
            ),
            _react2.default.createElement(
              'p',
              null,
              'At the bottom of the retirement plan scorecard, there\'s a section labeled "Source data" where the PDFs of the Form 5500 data and other documents used in the scorecard analysis are available.'
            ),
            _react2.default.createElement(_components.ScrollToTop, null),
            _react2.default.createElement('hr', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return Methodology;
}(_react.Component)) || _class);
exports.default = Methodology;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Methodology/Methodology.js
// module id = 1491
// module chunks = 0